<div [class.mt-3]="config().reportMode">
  @if (!config().reportMode) {
    <div class="test-button-group border-b-ui-gray-light border-b flex justify-between items-center mb-3 h-[64px]">
      <div class="flex-1">
        @if (config().statusFilter === undefined || config().statusFilter) {
          <mat-button-toggle-group
            class="desktop-toggle-group"
            (change)="filtersStore.patchFilters({ status: $event.value})"
            [value]="filtersStore.status()"
            aria-label="Device Status"
          >
            <mat-button-toggle
              class="test-device-status-current bg-transparent"
              [value]="eEntityStatus.Active"
            >
              <span class="item-status-title">Current</span>
            </mat-button-toggle>
            <mat-button-toggle
              class="test-device-status-archived bg-transparent"
              [value]="eEntityStatus.Archived"
            >
              <span class="item-status-title">Archived</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        }

        <ng-content />
      </div>

      @if (filtersStore.status() !== eEntityStatus.Archived) {
        <div class="test-search-panel flex justify-center">
          <app-table-search-input
            (searchDataEvent)="updateQuery($event)"
            [inputValue]="filtersStore.query()"
            [tableId]="tableId()"
            placeholder="Device Name, type & other"
          />
        </div>
      }
    </div>
  }

  <div class="flex">
    <div class="flex-1">
      <div [hidden]="!config().filtersEnabled || filtersStore.status() === eEntityStatus.Archived">
        <avs-li-filters-bar
          (filtersChanged)="filtersChanged.emit($event)"
          [config]="{
            building: config().locationFilter,
            floor: config().locationFilter,
          }"
          [filters]="filters()"
          [id]="tableId()"
        />
      </div>
    </div>

    @if (columnSelectOptions(); as options) {
      <div>
        <mat-form-field
          class="column-select mb-3 justify-self-end"
          appearance="outline"
          matTooltip="Column Select"
        >
          <mat-select
            (valueChange)="selectedColumns.set($event)"
            [value]="selectedColumns()"
            multiple
            panelClass="multi-select-overlay column-select-overlay"
          >
            <mat-select-trigger>
              <i class="icon-ic_column text-3xl"></i>
            </mat-select-trigger>
            <div class="options-action-wrapper">
              <button
                class="options-action-button"
                (click)="selectAllColumns()"
              >
                Select All
              </button>
            </div>

            @for (option of options; track option.value) {
              @if (option.isAdminColumn) {
                <mat-option
                  [value]="option.value"
                  avsRestrictedEl
                >
                  {{ option.title }}
                </mat-option>
              } @else {
                <mat-option [value]="option.value">
                  {{ option.title }}
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
</div>
